import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import EmojiSquares from '@app-studio-web/ui/components/EmojiSquares'
import PageLayout from '@app-studio-web/ui/components/PageLayout'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'

export default function FeedbackPage({
  emoji,
  title,
}: {
  emoji: string
  title: string
}) {
  const { t } = useTranslation()

  return (
    <PageLayout>
      <div className="flex grow flex-col items-center justify-center gap-14">
        <EmojiSquares emoji={emoji} />

        <p className="text-custom-black text-center text-xl text-balance">
          {t(title)}
        </p>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t(title, { lng: 'en' })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />

        <ContinueButton />
      </Form>
    </PageLayout>
  )
}
